






























import { Facet } from '@empathybroker/tsclient-play/dist/models/facet';
import { CatalogFieldConfig } from '@empathybroker/tsclient-play/dist/models/instance/catalog-field-config';

import { mapGetters } from 'vuex';

import { FacetSortTypeEnum } from '../../enums';

import { capitalizeSentence } from '../../filters';

import { CONFIG_CONSTS } from '../../store/config/config.consts';

import EpbButton from '../button.component.vue';
import { UiSelect, UiTextbox } from '../keen-ui';
import FacetsConfigurationList from './facets-configuration-list.component.vue';

export default {
  name: 'facets-configuration',
  components: {
    UiSelect,
    UiTextbox,
    EpbButton,
    FacetsConfigurationList
  },
  props: {
    configuration: {
      type: Object,
      required: true
    },
    messages: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance
    }),
    facetIdSelectOptions: function (): any[] {
      return this.instanceConfig.catalog.fields
        .reduce((facetIdOptions: any[], field: CatalogFieldConfig) => {
          if (field.facetable && !this.configuration.elements.find((facet: Facet) => (facet.id === field.id))) {
            facetIdOptions.push({
              value: field.id,
              label: capitalizeSentence((field.prettyName || field.id))
            });
          }
          return facetIdOptions;
        }, []);
    },
    sortTypeOptions: function (): any[] {
      const options = Object.values(FacetSortTypeEnum).map((sortType: FacetSortTypeEnum) => ({
        value: sortType,
        label: this.messages.sortType.values[sortType]
      }));
      options.unshift({
        value: undefined,
        label: this.messages.sortType.values.default
      });
      return options;
    },
    addFacetDisabled: function (): boolean {
      return !this.formValues.id;
    }
  },
  data: function () {
    return {
      formValues: {
        id: '',
        prettyName: '',
        sortType: ''
      },
      capitalizeSentence
    };
  },
  methods: {
    addFacet: function (): void {
      this.configuration.elements.push({
        id: this.formValues.id.value,
        prettyName: this.formValues.prettyName,
        sortType: this.formValues.sortType.value,
        values: []
      } as Facet);
      this.formValues = {
        id: '',
        prettyName: '',
        sortType: ''
      };
    }
  }
};
